export default __webpack_public_path__ + "static/media/ethereum.d20f4189.svg";